import { select } from '@ngrx/store'
import { pipe } from 'rxjs'
import { map } from 'rxjs/operators'
import { RootState } from '../../root.model'

const filterGroupsState = (state: RootState) => state.helios.filterGroups

export const selectFilterGroupsByPrefix = (prefix: string) =>
  pipe(
    select(filterGroupsState),
    map(state => state[prefix]),
  )
